import React, { useState, useEffect, useRef } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export default function CustomReactQuill({ value, formik, name, title }) {
  const [editorValue, setEditorValue] = useState("");

  useEffect(() => {
    // Ensure we have a clean value for the editor
    let newEditorValue = value || "";
    if (typeof newEditorValue === 'string' && newEditorValue && !newEditorValue.includes('<')) {
      newEditorValue = `<p>${newEditorValue}</p>`;
    }

    setEditorValue(prev => (prev !== newEditorValue ? newEditorValue : prev));
  }, [value]);

  const timeoutRef = useRef(null);

  const handleChange = (newValue) => {
    setEditorValue(newValue);

    // Debounce the Formik update to avoid stuttering and excessive parent re-renders
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      if (value !== newValue) {
        formik.setFieldValue(name, newValue);
      }
    }, 300); // 300ms debounce
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <div className="form-group">
      <label>
        {title ? title : (name == "deliverables" ? "Deliverables" : "Description")}
      </label>

      <ReactQuill
        theme="snow"
        className="form-control"
        value={editorValue}
        onChange={handleChange}
        modules={{
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean']
          ]
        }}
      />
    </div>
  );
}
